import { Instagram, Mail, Phone } from "lucide-react";
import { NAV_LINKS, INSTAGRAM_URL, WHATSAPP_NUMBER } from "./constants";

export const Footer = () => {
  const phoneDisplay = `+39 ${WHATSAPP_NUMBER.slice(2, 5)} ${WHATSAPP_NUMBER.slice(5, 8)} ${WHATSAPP_NUMBER.slice(8)}`;
  return (
    <footer
      data-testid="site-footer"
      className="bg-white border-t border-[#E1E7E3] pt-14 pb-8"
    >
      <div className="max-w-[1280px] mx-auto px-5 md:px-8">
        <div className="grid md:grid-cols-12 gap-10 pb-10 border-b border-[#E1E7E3]">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-full grid place-items-center bg-[#1F6E45] text-white font-display">
                S
              </span>
              <span className="font-heading text-[#0E1A14] text-lg font-bold tracking-tight">
                Sacco<span className="text-[#1F6E45]">.</span>Nutrizione
              </span>
            </div>
            <p className="mt-5 text-[#4A5A52] text-sm max-w-sm leading-relaxed">
              Dr. Christian Sacchetto — Biologo Nutrizionista. Programmi
              sartoriali per dimagrimento, ricomposizione corporea e
              performance sportiva.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.22em] text-[#1F6E45] font-bold mb-5">
              Navigazione
            </div>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-[#4A5A52] hover:text-[#1F6E45] text-sm transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs uppercase tracking-[0.22em] text-[#1F6E45] font-bold mb-5">
              Contatti
            </div>
            <ul className="space-y-3 text-[#4A5A52] text-sm">
              <li className="flex items-center gap-2">
                <Phone size={14} className="text-[#1F6E45]" />
                <a href={`tel:+${WHATSAPP_NUMBER}`} className="hover:text-[#1F6E45]">
                  {phoneDisplay}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Mail size={14} className="text-[#1F6E45]" />
                <a href="mailto:info@sacconutrizione.com" className="hover:text-[#1F6E45]">
                  info@sacconutrizione.com
                </a>
              </li>
              <li>Viale Quintino Sella 35/C, 36100 Vicenza</li>
              <li className="pt-1">
                <div className="font-semibold text-[#0E1A14] mb-1">Orari</div>
                <ul className="space-y-0.5 text-xs text-[#4A5A52]">
                  <li>Lun: 14:30 – 20:00</li>
                  <li>Mar: 11:00 – 20:00</li>
                  <li>Mer: Chiuso</li>
                  <li>Gio: 08:00 – 20:00</li>
                  <li>Ven: Chiuso</li>
                  <li>Sab: 08:00 – 14:00</li>
                  <li>Dom: Chiuso</li>
                </ul>
              </li>
            </ul>
            <div className="mt-5 flex items-center gap-3">
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                data-testid="footer-instagram"
                className="w-10 h-10 grid place-items-center rounded-full border border-[#E1E7E3] hover:border-[#1F6E45] hover:text-[#1F6E45] text-[#4A5A52] transition-colors"
              >
                <Instagram size={16} strokeWidth={1.8} />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-7 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <div className="text-xs text-[#6F7E76]">
            © {new Date().getFullYear()} Dr. Christian Sacchetto · Sacco Nutrizione
          </div>
          <div className="text-xs text-[#6F7E76]">
            Privacy · Cookie · Termini
          </div>
        </div>
      </div>
    </footer>
  );
};
